/* ════════════════════════════════════════════════════════
   PureEthical — pe-ui.js
   UI: hero slider, scroll reveal, recently viewed,
       hero countdown, back-to-top, marquee, cookie
   ════════════════════════════════════════════════════════ */
/* security 2026-10-05: escaping helpers */
var PE_esc = window.PE_esc || function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); };
var PE_url = window.PE_url || function (u, fb) { u = String(u == null ? '' : u); return /^\/(?!\/)/.test(u) ? PE_esc(u) : PE_esc(fb || '/'); };
var PE_img = window.PE_img || function (u) { u = String(u == null ? '' : u); return /^(https:)?\/\/[^\s"'<>]+$|^\/(?!\/)[^\s"'<>]*$/.test(u) ? PE_esc(u) : ''; };
window.PE_esc = PE_esc; window.PE_url = PE_url; window.PE_img = PE_img;


(function() {
'use strict';

document.addEventListener('DOMContentLoaded', function() {

/* ── Hero Slider ──────────────────────────────────────── */
(function() {
  var slides = PE.qsa('.hero-slide');
  var dots   = PE.qsa('.hero-dot');
  var prev   = PE.qs('#heroPrev');
  var next   = PE.qs('#heroNext');
  if (!slides.length) return;
  var cur = 0, timer;

  function goTo(n) {
    slides[cur].classList.remove('on');
    dots[cur] && dots[cur].classList.remove('on');
    cur = ((n % slides.length) + slides.length) % slides.length;
    slides[cur].classList.add('on');
    dots[cur] && dots[cur].classList.add('on');
  }
  function start() {
    if (slides.length < 2) return;
    timer = setInterval(function() { goTo(cur + 1); }, 6000);
  }
  function reset() { clearInterval(timer); start(); }

  dots.forEach(function(d, i) { d.addEventListener('click', function() { goTo(i); reset(); }); });
  if (prev) prev.addEventListener('click', function() { goTo(cur - 1); reset(); });
  if (next) next.addEventListener('click', function() { goTo(cur + 1); reset(); });

  /* Touch swipe on hero */
  var hx = 0;
  var hero = PE.qs('.hero');
  if (hero) {
    hero.addEventListener('touchstart', function(e) { hx = e.touches[0].clientX; }, { passive: true });
    hero.addEventListener('touchend',   function(e) {
      var dx = e.changedTouches[0].clientX - hx;
      if (Math.abs(dx) > 50) { goTo(dx < 0 ? cur + 1 : cur - 1); reset(); }
    }, { passive: true });
  }
  start();
})();

/* ── Scroll Reveal ────────────────────────────────────── */
(function() {
  var els = PE.qsa('[data-reveal], .fade-in');
  if (!els.length) return;
  var io = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.isIntersecting) {
        e.target.classList.add('visible');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
  els.forEach(function(el) { io.observe(el); });

  /* Stagger children */
  PE.qsa('.stagger').forEach(function(s) { io.observe(s); });
})();

/* ── Page Progress Bar ────────────────────────────────── */
(function() {
  var bar = PE.qs('#page-progress');
  if (!bar) return;
  window.addEventListener('scroll', function() {
    var d = document.documentElement;
    var p = d.scrollTop / (d.scrollHeight - d.clientHeight);
    bar.style.width   = (p * 100) + '%';
    bar.style.opacity = p > 0.01 ? '1' : '0';
  }, { passive: true });
})();

/* ── Back to Top ──────────────────────────────────────── */
(function() {
  var btt = PE.qs('.btt, #backToTop');
  if (!btt) return;
  window.addEventListener('scroll', function() {
    btt.style.opacity = window.scrollY > 400 ? '1' : '0';
    btt.style.pointerEvents = window.scrollY > 400 ? 'auto' : 'none';
  }, { passive: true });
  btt.addEventListener('click', function() { window.scrollTo({ top: 0, behavior: 'smooth' }); });
})();

/* ── Recently Viewed ──────────────────────────────────── */
(function() {
  var RV_KEY = 'pe_rv';
  var MAX    = 12;

  function getRV() {
    try { return JSON.parse(localStorage.getItem(RV_KEY) || '[]'); } catch(e) { return []; }
  }

  /* Record current product */
  var pid = document.body.dataset.pid;
  if (pid) {
    var rv  = getRV().filter(function(p) { return p.id !== pid; });
    var img = PE.qs('.gs-slide.active img') || PE.qs('.gs-slide img');
    rv.unshift({
      id:    pid,
      url:   window.location.pathname,
      title: document.title.split(' – ')[0],
      img:   img ? img.src : ''
    });
    if (rv.length > MAX) rv = rv.slice(0, MAX);
    try { localStorage.setItem(RV_KEY, JSON.stringify(rv)); } catch(e) {}
  }

  /* Render RV section */
  var wrap = PE.qs('#rvSection');
  if (!wrap) return;
  var rv = getRV().filter(function(p) { return !pid || p.id !== pid; }).slice(0, 6);
  if (!rv.length) return;

  var inner = PE.qs('#rvItems');
  if (!inner) return;
  inner.innerHTML = rv.map(function(p) {
    var rvImg = p.img ? PE_img(String(p.img).replace(/(_\d+x\d*)?\.(\w+)$/, '_200x.$2')) : '';
    return '<a href="' + PE_url(p.url, '/') + '" class="rv-card" aria-label="' + PE_esc(p.title) + '">' +
      (rvImg ? '<img src="' + rvImg + '" alt="' + PE_esc(p.title) + '" loading="lazy">' : '<div class="rv-ph"></div>') +
      '<p class="rv-name">' + PE_esc(p.title) + '</p>' +
    '</a>';
  }).join('');
  wrap.style.display = '';
})();

/* ── Marquee pause on hover ───────────────────────────── */
(function() {
  PE.qsa('.marquee-track, .ann-track').forEach(function(t) {
    t.addEventListener('mouseenter', function() { t.style.animationPlayState = 'paused'; });
    t.addEventListener('mouseleave', function() { t.style.animationPlayState = 'running'; });
  });
})();

/* ── Cookie Consent ───────────────────────────────────── */
(function() {
  /* v27: o aviso passa a registar o consentimento real na Shopify (Customer Privacy API - RGPD).
     Aceitar = analise + marketing + preferencias; Recusar = so o essencial.
     3AL-C (2026-10-10): o aviso proprio so aparece quando, pela API documentada da Shopify,
     (1) ainda nao ha decisao, (2) shouldShowBanner() e false (o aviso nativo nao aparece) e
     (3) analyticsProcessingAllowed() e true sem decisao (a regiao nao exige consentimento),
     com regiao conhecida (getRegion). Em qualquer duvida (API indisponivel, sinais contraditorios,
     regiao vazia) fica escondido e nada e gravado. O motivo fica em data-pe-consent. */
  var stored = null;
  try { stored = localStorage.getItem('pe_cookie_ok'); } catch(e) {}
  var banner = PE.qs('#cookieBanner');
  function withPrivacy(cb){
    try {
      if (window.Shopify && Shopify.customerPrivacy) return cb(Shopify.customerPrivacy);
      if (window.Shopify && Shopify.loadFeatures) {
        Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function(err){ if (!err && Shopify.customerPrivacy) cb(Shopify.customerPrivacy); });
      }
    } catch(e) {}
  }
  function setConsent(ok, done){
    withPrivacy(function(cp){
      try { cp.setTrackingConsent({ analytics: ok, marketing: ok, preferences: ok, sale_of_data: ok }, function(r){ if (r && r.error) { mark('erro-registo'); return; } if (done) done(); }); } catch(e) { mark('erro-registo'); }
    });
  }
  /* 3AV: pe_cookie_ok deixa de decidir sozinho - o estado vem sempre da Shopify (abaixo) */
  if (!banner) return;
  /* comeca escondido; so passa a visivel se todas as condicoes se confirmarem */
  banner.style.display = 'none';
  function mark(v){ try { banner.setAttribute('data-pe-consent', v); } catch(e) {} }
  mark('a-aguardar-api');
  withPrivacy(function(cp){
    try {
      if (typeof cp.currentVisitorConsent !== 'function' || typeof cp.shouldShowBanner !== 'function' ||
          typeof cp.analyticsProcessingAllowed !== 'function' || typeof cp.getRegion !== 'function') { mark('api-incompleta'); return; }
      var c = cp.currentVisitorConsent();
      if (!c || typeof c !== 'object') { mark('estado-desconhecido'); return; }
      if (c.analytics !== '' || c.marketing !== '' || c.preferences !== '') { mark('decisao-existente'); return; }
      if (cp.shouldShowBanner() !== false) { mark('aviso-nativo'); return; }
      if (cp.analyticsProcessingAllowed() !== true) { mark('sinais-contraditorios'); return; }
      if (!cp.getRegion()) { mark('regiao-desconhecida'); return; }
      mark('mostrar');
      banner.style.display = '';
      document.addEventListener('visitorConsentCollected', function(){ banner.style.display = 'none'; mark('decisao-recebida'); });
    } catch(e) { mark('erro'); banner.style.display = 'none'; }
  });
  var btnA = PE.qs('#cookieAccept');
  var btnD = PE.qs('#cookieDecline');
  var closed = false; function closeCookie(v){ if (closed) return; closed = true; try { localStorage.setItem('pe_cookie_ok', v); } catch(e) {} banner.style.display='none'; }
  if(btnA) btnA.addEventListener('click', function(){ setConsent(true, function(){ closeCookie('yes'); }); });
  if(btnD) btnD.addEventListener('click', function(){ setConsent(false, function(){ closeCookie('no'); }); });
})();

/* ── Header scroll effect ─────────────────────────────── */
(function() {
  var hdr = PE.qs('.site-header');
  if (!hdr) return;
  window.addEventListener('scroll', function() {
    hdr.classList.toggle('scrolled', window.scrollY > 10);
  }, { passive: true });
})();

/* ── Search ───────────────────────────────────────────── */
(function() {
  var form  = PE.qs('#searchForm');
  var input = PE.qs('#searchInput');
  if (form) {
    form.addEventListener('submit', function(e) {
      if (!input || !input.value.trim()) e.preventDefault();
    });
  }
})();

/* ── Sort select (collection) ─────────────────────────── */
(function() {
  var sel = PE.qs('#sortSel');
  if (!sel) return;
  sel.addEventListener('change', function() {
    if (sel.value) window.location.href = sel.value;
  });
})();

/* ── Scroll-triggered animation for stats ────────────── */
(function() {
  var counters = PE.qsa('[data-count-to]');
  if (!counters.length) return;
  var io = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (!entry.isIntersecting) return;
      var el  = entry.target;
      el.classList.add('notranslate');
      el.setAttribute('translate','no');
      var end = parseInt(el.dataset.countTo);
      var dur = 2000;
      var step = dur / end;
      var n = 0;
      var t = setInterval(function() {
        n += Math.ceil(end / (dur / 16));
        if (n >= end) { n = end; clearInterval(t); }
        el.textContent = n.toLocaleString() + (el.dataset.suffix || '');
      }, 16);
      io.unobserve(el);
    });
  }, { threshold: 0.5 });
  counters.forEach(function(c) { io.observe(c); });
})();


  /* ── Wishlist Drawer ─────────────────────────────────── */
  var WL_KEY_V2 = 'pe_wl_v2';
  function getWL() {
    try { return JSON.parse(localStorage.getItem(WL_KEY_V2) || localStorage.getItem('pe_wl') || '[]'); }
    catch(e) { return []; }
  }

  function renderWishlistDrawer() {
    if (window.syncWishlistUI) window.syncWishlistUI();
    var items = document.getElementById('wlItems');
    var empty = document.getElementById('wlEmpty');
    var badge = document.getElementById('wlBadge');
    if (!items) return;

    var wl = getWL();
    if (badge) { badge.textContent = wl.length || ''; badge.classList.toggle('show', wl.length > 0); }
    var wlCount = document.getElementById('wlCount'); /* v30 Fase 1G: contador no titulo da gaveta */
    if (wlCount) wlCount.textContent = wl.length ? String(wl.length) : '';

    if (wl.length === 0) {
      items.innerHTML = '';
      if (empty) empty.style.display = '';
      return;
    }
    if (empty) empty.style.display = 'none';

    var html = '';
    wl.forEach(function(p) {
      var pid   = (typeof p === 'object') ? (p.pid || '') : p;
      var title = (typeof p === 'object') ? (p.title || 'Product') : 'Product';
      var price = (typeof p === 'object') ? (p.price || '') : '';
      var url   = (typeof p === 'object') ? (p.url   || '/collections/all') : '/collections/all';
      var img   = (typeof p === 'object') ? (p.img   || '') : '';
      var brand = (typeof p === 'object') ? (p.vendor || '') : ''; /* v30 Fase 1G: marca, quando foi guardada */

      html +=
        '<div class="wl-item" data-pid="' + PE_esc(pid) + '">' +
          '<a href="' + PE_url(url, '/collections/all') + '" class="wl-item-img">' +
            (PE_img(img) ? '<img src="' + PE_img(img) + '" alt="' + PE_esc(title) + '" loading="lazy">' : '<div class="wl-item-img-ph"></div>') +
          '</a>' +
          '<div class="wl-item-info">' +
            (brand ? '<p class="wl-item-brand notranslate" translate="no">' + PE_esc(brand) + '</p>' : '') +
            '<a href="' + PE_url(url, '/collections/all') + '" class="wl-item-name">' + PE_esc(title) + '</a>' +
            (price ? '<span class="wl-item-price">' + PE_esc(price) + '</span>' : '') +
          '</div>' +
          '<button class="wl-item-remove" type="button" data-pid="' + PE_esc(pid) + '" aria-label="' + (window.PE_T?window.PE_T('remove_x','Remove'):'Remove') + ': ' + PE_esc(title) + '">&times;</button>' + /* v30 Fase 1J: diz qual artigo */
        '</div>';
    });
    items.innerHTML = html;
  }
  window.renderWishlistDrawer = renderWishlistDrawer;

  /* Open/close wishlist drawer */
  var wlLastFocus = null; /* v30 Fase 1G: foco no botao fechar ao abrir; volta ao botao que abriu ao fechar */
  function openWL() {
    wlLastFocus = (document.activeElement && document.activeElement !== document.body) ? document.activeElement : null;
    var drawer  = document.getElementById('wlDrawer');
    var overlay = document.getElementById('wlOverlay');
    if (drawer)  { drawer.classList.add('open'); drawer.setAttribute('aria-hidden', 'false'); }
    if (overlay) overlay.classList.add('open');
    PE.lockScroll();
    renderWishlistDrawer();
    setTimeout(function () { var c = document.getElementById('wlClose'); if (c && drawer && drawer.classList.contains('open')) { try { c.focus({ preventScroll: true }); } catch (e) {} } }, 80);
  }
  function closeWL() {
    var drawer  = document.getElementById('wlDrawer');
    var overlay = document.getElementById('wlOverlay');
    if (drawer)  { drawer.classList.remove('open'); drawer.setAttribute('aria-hidden', 'true'); }
    if (overlay) overlay.classList.remove('open');
    PE.unlockScroll();
    var lf = wlLastFocus; wlLastFocus = null;
    if (lf && lf.focus && document.body.contains(lf)) { try { lf.focus({ preventScroll: true }); } catch (e) {} }
  }
  window.openWL = openWL;

  var wlBtn  = PE.qs('#wishlistBtn');
  var wlCls  = PE.qs('#wlClose');
  var wlOver = PE.qs('#wlOverlay');
  if (wlBtn)  wlBtn.addEventListener('click',  openWL);
  if (wlCls)  wlCls.addEventListener('click',  closeWL);
  if (wlOver) wlOver.addEventListener('click', closeWL);
  /* v30 Fase 1F: Escape fecha os favoritos, como ja fecha o cesto e o menu */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var d = document.getElementById('wlDrawer');
    if (d && d.classList.contains('open')) closeWL();
  });

  /* Remove from wishlist via drawer */
  document.addEventListener('click', function(e) {
    var rmBtn = e.target.closest('.wl-item-remove[data-pid]');
    if (!rmBtn) return;
    var pid = rmBtn.dataset.pid;
    var rmIdx = Array.prototype.indexOf.call(document.querySelectorAll('#wlDrawer .wl-item-remove'), rmBtn); /* v30 Fase 1J */
    var wl  = getWL();
    wl = wl.filter(function(p) { return String(typeof p === 'object' ? p.pid : p) !== String(pid); });
    localStorage.setItem(WL_KEY_V2, JSON.stringify(wl));
    document.querySelectorAll('.pc-wish[data-pid="'+pid+'"]').forEach(function(b){
      b.classList.remove('active');
      b.setAttribute('aria-pressed','false');
      var svg = b.querySelector('svg');
      if (svg){ svg.style.fill='none'; svg.style.stroke='#111111'; }
    });
    renderWishlistDrawer();
    /* v30 Fase 1J: a lista e redesenhada - o foco passa para o artigo seguinte (ou para fechar), em vez de se perder */
    var dr = document.getElementById('wlDrawer');
    if (dr && dr.classList.contains('open') && rmIdx > -1) {
      var rs = dr.querySelectorAll('.wl-item-remove');
      var nx = rs.length ? rs[Math.min(rmIdx, rs.length - 1)] : document.getElementById('wlClose');
      if (nx) { try { nx.focus({ preventScroll: true }); } catch (err) {} }
    }
  });

  /* Initial badge sync */
  (function(){
    var wl = getWL();
    var badge = PE.qs('#wlBadge');
    if (badge) { badge.textContent = wl.length||''; badge.style.display = wl.length ? '' : 'none'; }
  })();



(function(){
  var inp=document.getElementById('searchInput')||document.querySelector('input[name="q"]');
  var pred=document.getElementById('searchPredict');
  if(!inp||!pred)return;
  var t;
  inp.addEventListener('input',function(){
    clearTimeout(t);
    var q=inp.value.trim();
    if(q.length<2){pred.innerHTML='';pred.style.display='none';return;}
    t=setTimeout(function(){
      fetch('/search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product&resources[limit]=6')
        .then(function(r){return r.json();})
        .then(function(d){
          var ps=(d&&d.resources&&d.resources.results&&d.resources.results.products)||[];
          if(!ps.length){pred.style.display='none';return;}
          pred.innerHTML=ps.map(function(p){
            return '<a href="'+PE_url(p.url,'/')+'" class="sp-item"><div class="sp-img">'+(p.image?'<img src="'+PE_img(p.image)+'" alt="" loading="lazy">':'')+'</div><div><p class="sp-name">'+PE_esc(p.title)+'</p>'+(p.price?'<p class="sp-price">'+PE_esc(p.price)+'</p>':'')+'</div></a>';
          }).join('')+'<a href="/search?q='+encodeURIComponent(q)+'" class="sp-all">Ver todos →</a>';
          pred.style.display='block';
        }).catch(function(){pred.style.display='none';});
    },220);
  });
  document.addEventListener('click',function(e){if(!pred.contains(e.target)&&e.target!==inp)pred.style.display='none';});
})();
}); /* end DOMContentLoaded */

})();

/* ═══════════════════════════════════════════════════════════
   PATCH v1: Mobile nav v2 + Size Guide v2
   Injected via pe-ui.js to override inline header styles
   ═══════════════════════════════════════════════════════════ */
(function() {

/* ── Mobile nav CSS override (runs after DOMContentLoaded, wins cascade) ── */
var mnStyle = document.createElement('style');
mnStyle.textContent = [
  '.mn-link{font-size:14.5px!important;font-weight:600!important}',
  '.mn-foot-row .mn-btn-new,.mn-foot-row .mn-btn-sale{padding:10px 10px!important;border-radius:4px!important}',
  '.mn-foot-row .mn-btn-new{box-shadow:0 2px 8px rgba(74,140,99,.2)!important}',
  '.mn-foot-row .mn-btn-sale{box-shadow:0 2px 8px rgba(232,128,90,.2)!important}',
  '.mn-foot-row .mn-btn-new::before,.mn-foot-row .mn-btn-sale::before{background:linear-gradient(105deg,transparent,rgba(255,255,255,.10),transparent)!important}'
].join('');
document.head.appendChild(mnStyle);

/* ── Size Guide v2 CSS ─────────────────────────────────── */
var sgStyle = document.createElement('style');
sgStyle.textContent = [
  '.sg-overlay{display:none!important;position:fixed!important;inset:0!important;background:rgba(0,0,0,.65)!important;z-index:4000!important;align-items:center!important;justify-content:center!important;padding:16px!important}',
  '.sg-overlay.open{display:flex!important}',
  '.sg-modal{background:#fff!important;border-radius:16px!important;max-width:560px!important;width:100%!important;max-height:92vh!important;overflow-y:auto!important;position:relative!important;box-shadow:0 20px 60px rgba(0,0,0,.25)!important}',
  '.sg-hdr{display:flex!important;align-items:center!important;justify-content:space-between!important;padding:20px 24px 16px!important;border-bottom:1px solid #f0ede8!important}',
  '.sg-hdr-left{display:flex!important;align-items:center!important;gap:10px!important}',
  '.sg-hdr-icon{color:#17211A!important;opacity:.5!important;flex-shrink:0!important}',
  '.sg-title{font-size:16px!important;font-weight:700!important;letter-spacing:.02em!important;color:#17211A!important;margin:0!important}',
  '.sg-close{background:none!important;border:none!important;cursor:pointer!important;padding:6px!important;color:#767676!important;border-radius:50%!important;display:flex!important;align-items:center!important;justify-content:center!important;width:32px!important;height:32px!important}',
  '.sg-close:hover{background:#f5f4f0!important;color:#17211A!important}',
  '.sg-tabs{display:flex!important;padding:0 24px!important;border-bottom:1px solid #f0ede8!important}',
  '.sg-tab{background:none!important;border:none!important;padding:12px 20px!important;font-size:13px!important;font-weight:600!important;color:#aaa!important;cursor:pointer!important;border-bottom:2px solid transparent!important;margin-bottom:-1px!important;letter-spacing:.04em!important;transition:color .15s!important}',
  '.sg-tab.active{color:#17211A!important;border-bottom-color:#17211A!important}',
  '.sg-panel{padding:20px 24px!important}',
  '.sg-mguide{display:flex!important;gap:14px!important;align-items:flex-start!important;background:#f5f4f0!important;border-radius:10px!important;padding:14px!important;margin-bottom:16px!important}',
  '.sg-mguide-tips{flex:1!important}',
  '.sg-mguide-tips p{font-size:12px!important;color:#666!important;margin:0 0 4px!important;line-height:1.5!important}',
  '.sg-mguide-tips p:first-child{font-size:13px!important;font-weight:700!important;color:#17211A!important;margin-bottom:8px!important}',
  '.sg-table{width:100%!important;border-collapse:collapse!important;font-size:13px!important}',
  '.sg-table thead tr{background:#17211A!important}',
  '.sg-table th{color:#fff!important;padding:10px 12px!important;text-align:left!important;font-size:11px!important;font-weight:600!important;letter-spacing:.08em!important;text-transform:uppercase!important}',
  '.sg-table td{padding:10px 12px!important;border-bottom:1px solid #f0ede8!important;color:#17211A!important;font-size:13px!important}',
  '.sg-table tr:last-child td{border-bottom:none!important}',
  '.sg-table tbody tr:hover td{background:#faf9f7!important}',
  '.sg-table td:first-child{font-weight:700!important;color:#E8805A!important}',
  '.sg-note{font-size:11px!important;color:#aaa!important;padding:0 24px 20px!important;text-align:center!important;line-height:1.6!important;margin:0!important}',
  '@media(max-width:480px){.sg-modal{border-radius:16px 16px 0 0!important;position:fixed!important;bottom:0!important;left:0!important;right:0!important;max-width:100%!important;max-height:85vh!important;margin:0!important}}'
].join('\n');
document.head.appendChild(sgStyle);

/* ── Size Guide v2 HTML replacement ───────────────────── */
document.addEventListener('DOMContentLoaded', function() {
  var modal = document.querySelector('.sg-modal');
  if (!modal) return;

  modal.innerHTML = [
    '<div class="sg-hdr">',
      '<div class="sg-hdr-left">',
        '<svg class="sg-hdr-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M2 9h20M2 15h20M9 3v18M15 3v18"/></svg>',
        '<h2 class="sg-title">Size Guide</h2>',
      '</div>',
      '<button class="sg-close" id="sgClose" aria-label="' + (window.PE_T?window.PE_T('close_x','Close'):'Close') + '">',
        '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>',
      '</button>',
    '</div>',
    '<div class="sg-tabs">',
      '<button class="sg-tab active" data-sgtab="women" type="button">Women</button>',
      '<button class="sg-tab" data-sgtab="men" type="button">Men</button>',
    '</div>',
    '<div class="sg-panel" id="sg-panel-women">',
      '<div class="sg-mguide">',
        '<svg width="48" height="64" viewBox="0 0 48 64" fill="none">',
          '<ellipse cx="24" cy="9" rx="7" ry="7" stroke="#17211A" stroke-width="1.5"/>',
          '<path d="M24 16 C24 16 14 22 14 32 L14 42 L34 42 L34 32 C34 22 24 16 24 16Z" stroke="#17211A" stroke-width="1.5" fill="none"/>',
          '<line x1="14" y1="42" x2="18" y2="60" stroke="#17211A" stroke-width="1.5"/>',
          '<line x1="34" y1="42" x2="30" y2="60" stroke="#17211A" stroke-width="1.5"/>',
          '<line x1="2" y1="28" x2="8" y2="28" stroke="#E8805A" stroke-width="1.5"/>',
          '<line x1="40" y1="28" x2="46" y2="28" stroke="#E8805A" stroke-width="1.5"/>',
        '</svg>',
        '<div class="sg-mguide-tips">',
          '<p>How to measure</p>',
          '<p>Chest — Around the fullest part of your bust</p>',
          '<p>Waist — Around your natural waistline</p>',
          '<p>Hips — Around the fullest part of your hips</p>',
        '</div>',
      '</div>',
      '<table class="sg-table">',
        '<thead><tr><th>Size</th><th>Chest (cm)</th><th>Waist (cm)</th><th>Hips (cm)</th><th>Chest (in)</th></tr></thead>',
        '<tbody>',
          '<tr><td>XS</td><td>79–84</td><td>61–66</td><td>87–92</td><td>31–33</td></tr>',
          '<tr><td>S</td><td>84–89</td><td>66–71</td><td>92–97</td><td>33–35</td></tr>',
          '<tr><td>M</td><td>89–94</td><td>71–76</td><td>97–102</td><td>35–37</td></tr>',
          '<tr><td>L</td><td>94–99</td><td>76–81</td><td>102–107</td><td>37–39</td></tr>',
          '<tr><td>XL</td><td>99–104</td><td>81–86</td><td>107–112</td><td>39–41</td></tr>',
          '<tr><td>XXL</td><td>104–109</td><td>86–91</td><td>112–117</td><td>41–43</td></tr>',
        '</tbody>',
      '</table>',
    '</div>',
    '<div class="sg-panel" id="sg-panel-men" style="display:none">',
      '<table class="sg-table">',
        '<thead><tr><th>Size</th><th>Chest (cm)</th><th>Waist (cm)</th><th>Chest (in)</th><th>Waist (in)</th></tr></thead>',
        '<tbody>',
          '<tr><td>XS</td><td>86–91</td><td>71–76</td><td>34–36</td><td>28–30</td></tr>',
          '<tr><td>S</td><td>91–96</td><td>76–81</td><td>36–38</td><td>30–32</td></tr>',
          '<tr><td>M</td><td>96–101</td><td>81–86</td><td>38–40</td><td>32–34</td></tr>',
          '<tr><td>L</td><td>101–106</td><td>86–91</td><td>40–42</td><td>34–36</td></tr>',
          '<tr><td>XL</td><td>106–111</td><td>91–96</td><td>42–44</td><td>36–38</td></tr>',
          '<tr><td>XXL</td><td>111–116</td><td>96–101</td><td>44–46</td><td>38–40</td></tr>',
        '</tbody>',
      '</table>',
    '</div>',
    '<p class="sg-note">Between sizes? We recommend sizing up for a more comfortable fit.</p>'
  ].join('');

  /* Tab switching */
  modal.querySelectorAll('.sg-tab').forEach(function(tab) {
    tab.addEventListener('click', function() {
      var t = tab.getAttribute('data-sgtab');
      modal.querySelectorAll('.sg-tab').forEach(function(b) { b.classList.remove('active'); });
      modal.querySelectorAll('.sg-panel').forEach(function(p) { p.style.display = 'none'; });
      tab.classList.add('active');
      var panel = document.getElementById('sg-panel-' + t);
      if (panel) panel.style.display = '';
    });
  });

  /* Re-wire close button after HTML replacement */
  var sgClose = document.getElementById('sgClose');
  var sgOverlay = document.getElementById('sgOverlay');
  if (sgClose && sgOverlay) {
    sgClose.addEventListener('click', function() { sgOverlay.classList.remove('open'); });
  }
  if (sgOverlay) {
    sgOverlay.addEventListener('click', function(e) {
      if (e.target === sgOverlay) sgOverlay.classList.remove('open');
    });
  }
});

})();